import { useEffect, useState } from "react";
import { Loader2, X } from "lucide-react";
import { api, imgUrl } from "@/lib/api";

export default function MediaPicker({ kind = "image", onSelect, onClose }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api
      .get("/admin/media")
      .then((r) => setItems(r.data.filter((m) => (kind === "video" ? m.kind === "video" : m.kind !== "video"))))
      .catch(() => setItems([]));
  }, [kind]);

  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center md:items-center md:p-8">
      <div className="absolute inset-0 bg-ink/60 backdrop-blur-sm" onClick={onClose} aria-hidden />
      <div data-testid="media-picker" role="dialog" aria-modal="true" className="relative flex max-h-[85vh] w-full max-w-3xl flex-col rounded-t-3xl bg-white p-6 md:rounded-3xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="font-serif text-2xl font-medium">Choose from Media</h3>
          <button data-testid="media-picker-close" onClick={onClose} aria-label="Close media picker" className="flex h-10 w-10 items-center justify-center rounded-full border border-line transition-colors hover:bg-ink hover:text-cream">
            <X size={16} />
          </button>
        </div>
        <div className="overflow-y-auto">
          {!items ? (
            <div className="flex justify-center py-16"><Loader2 size={24} className="animate-spin text-rose" /></div>
          ) : items.length === 0 ? (
            <p className="py-16 text-center text-sm text-[#5C5C5C]">No media uploaded yet. Upload files in the Media tab first.</p>
          ) : (
            <div className="grid grid-cols-3 gap-3 sm:grid-cols-4">
              {items.map((m) => (
                <button
                  key={m.id}
                  data-testid={`media-pick-${m.id}`}
                  onClick={() => onSelect(m.path)}
                  className="group relative overflow-hidden rounded-xl border border-line transition-colors hover:border-rose"
                >
                  {m.kind === "video" ? (
                    <video src={imgUrl(m.path)} className="aspect-square w-full object-cover" muted />
                  ) : (
                    <img src={imgUrl(m.path)} alt={m.label} className="aspect-square w-full object-cover" />
                  )}
                  <span className="absolute inset-0 bg-rose/0 transition-colors group-hover:bg-rose/20" />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
